import CreateTest from "../components/CreateTest/CreateTest"
const CreateTestPage = () => {
    return <CreateTest/>
}
export default CreateTestPage;